import { FC } from "react";
import Typography from "@/components/Typography";
import Button from "@/components/Button";
import styles from "./CategoryTitle.module.scss";

type Props = {
  title: string;
  onClick: () => void;
};

const CategoryTitle: FC<Props> = ({ title, onClick }) => {
  return (
    <div className={styles.container}>
      <Typography color="text.secondary" variant="h6">
        {title}
      </Typography>
      <Button variant="text" className={styles.button} onClick={onClick}>
        See all
      </Button>
    </div>
  );
};

export default CategoryTitle;
